import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import sendNotification from '../../../../notifications/sendNotification';
import { useUserInfoData } from '../../../Hooks/useUserInfo';
import { isStartSessionMessage, isStopSessionMessage } from '../Contexts/WebsocketConnectionProviders/WebsocketApiConnectionContext/types';
import useWebsocketApiConnectionContext from '../Contexts/WebsocketConnectionProviders/WebsocketApiConnectionContext/useWebsocketApiConnectionContext';
import useSessionInfo from './useSessionInfo';
import useStartSession from './useStartSession';
import useStopSession from './useStopSession';

export default function useHandleExternalCallEvents() {
  const { lastJsonMessage } = useWebsocketApiConnectionContext();
  const notificationSettings = useUserInfoData().appSettings?.notifications;
  const startSession = useStartSession();
  const stopSession = useStopSession();
  const session = useSessionInfo();

  const previous = React.useRef({ stopSession, sessionId: session?.id, externalCallId: session?.externalCallId });
  React.useEffect(() => {
    previous.current = { stopSession, sessionId: session?.id, externalCallId: session?.externalCallId };
  }, [stopSession, session?.id, session?.externalCallId]);

  React.useEffect(() => {
    if (!lastJsonMessage) return;

    if (isStartSessionMessage(lastJsonMessage)) {
      if (notificationSettings?.notifyOnExternalCall) {
        sendNotification({ type: 'external-call-started' });
      }
      if (previous.current.sessionId && previous.current.stopSession) {
        previous.current.stopSession('ExternalCallReplaced');
      }
      startSession({
        id: uuidv4(),
        projectId: lastJsonMessage.session.projectId,
        externalCallId: lastJsonMessage.session.cogneedId,
      });
      return;
    }

    if (isStopSessionMessage(lastJsonMessage)) {
      if (!lastJsonMessage.externalCallId || lastJsonMessage.externalCallId === previous.current.externalCallId) {
        stopSession('ExternalCallEnd');
      }
    }
  }, [lastJsonMessage]);
}
